export default {
    text: 'Are you sure you want to remove the social network {{0}} ?',
    buttons: {
        confirm: 'Yes, delete',
        cancel: 'Cancel',
    },
};
